import { Button, Color, Flex, Grid, Icon, Text } from "src/elements";
import { useTranslation } from "src/i18n";
import { colorToRGBA } from "src/utils/colorToRgba";
import { CONFLICT_SIDES, ConflictSideKey, RuleConflict } from "../conflicts";
import { DraftRule } from "../types";

interface Props {
  conflicts: RuleConflict[];
  ruleLabel: (rule: DraftRule) => string;
  onKeep: (conflict: RuleConflict, side: ConflictSideKey) => void;
}

export const ConflictPanel = ({ conflicts, ruleLabel, onKeep }: Props) => {
  const { t } = useTranslation("planogramDelivery");

  return (
    <Flex
      column
      gap="10px"
      padding="10px"
      background={colorToRGBA(Color.red, 0.06)}
      borderColor={Color.red}
      borderRadius="4px"
    >
      <Flex gap="6px" align="center">
        <Icon name="alert" color={Color.red} size={14} />
        <Text variant="body2" color={Color.red}>
          {t("variantRestrictionDescribe.conflictsTitle")}
        </Text>
      </Flex>

      <Text variant="caption2" color={Color.textSecondary}>
        {t("variantRestrictionDescribe.conflictsHelp")}
      </Text>

      {conflicts.map((conflict) => (
        <Flex key={conflict.key} column gap="6px">
          <Text variant="body3">
            {t(
              conflict.reason === "REQUIRED_AND_FORBIDDEN"
                ? "variantRestrictionDescribe.conflictRequiredAndForbidden"
                : "variantRestrictionDescribe.conflictOutsideAllowedSet",
              { variant: conflict.variant },
            )}
          </Text>

          <Grid columns="1fr 1fr" gap="8px" align="top">
            {CONFLICT_SIDES.map((side) => {
              const { groupIndex, rule } = conflict[side];
              return (
                <Flex
                  key={rule.id}
                  column
                  gap="6px"
                  padding="8px"
                  justify="between"
                  borderColor={Color.lightGrayHover}
                  borderRadius="4px"
                >
                  <Flex column gap="2px">
                    <Text variant="small2" color={Color.textSecondary}>
                      {t("variantRestrictionDescribe.groupName", { index: groupIndex + 1 })}
                    </Text>
                    <Text variant="body3">{ruleLabel(rule)}</Text>
                  </Flex>

                  <Flex>
                    <Button
                      name={`keep-conflict-rule-${conflict.key}-${side}`}
                      variant="inverted"
                      size="small"
                      onClick={() => onKeep(conflict, side)}
                    >
                      {t("variantRestrictionDescribe.keepThisRule")}
                    </Button>
                  </Flex>
                </Flex>
              );
            })}
          </Grid>
        </Flex>
      ))}
    </Flex>
  );
};
